import { alpha } from '@mui/material/styles';
import { blue02, blue10 } from '../../../colors/blue';
import { gray20, gray35, gray40opacity10, gray40opacity20, gray95 } from '../../../colors/gray';
import { red01 } from '../../../colors/red';
import { yellow01 } from '../../../colors/yellow';
import { MuiListItem } from './MuiListItem';
// Style listItemButtom with the same style as listItem
export var MuiListItemButton = {
    styleOverrides: MuiListItem.styleOverrides,
    customOverrides: {
        topNavItem: {
            // Focus, hover and selected states are taken from root
            '&[class*=Mui-selected]': {
                color: blue10,
            },
        },
        topNavButton: {
            // Focus, hover and selected states are taken from root
            color: gray35,
            '&[class*=Mui-selected]': {
                color: blue10,
            },
            warning: {
                '--yds-top-nav-btn-color': yellow01,
                '--yds-top-nav-btn-color-hover': alpha(yellow01, 0.9),
                '--yds-top-nav-btn-text-color': gray95,
            },
            error: {
                '--yds-top-nav-btn-color': red01,
                '--yds-top-nav-btn-color-hover': alpha(red01, 0.9),
                '--yds-top-nav-btn-text-color': 'black',
            },
        },
        sideNavItem: {
            color: gray20,
            '& [class*=MuiListItemIcon-root]': {
                color: gray35,
            },
            '&:hover': { backgroundColor: gray40opacity10 },
            '&[class*=Mui-selected]': {
                backgroundColor: gray40opacity20,
                color: blue10,
                '& [class*=MuiListItemIcon-root]': {
                    color: 'inherit',
                },
            },
            '&[class*=Mui-focusVisible]': {
                boxShadow: "0 0 0 1px ".concat(blue02),
                '&:not(:hover)': { backgroundColor: 'transparent' },
            },
        },
    },
};
